/**
 * AUTO-GENERATED - Do not edit manually.
 * Run: node scripts/generate-entry.js
 * 
 * This file exports all civics-common modules so they can be bundled
 * into a single shared CivicsCommon.js file.
 */
module.exports = {
  base: {
    data_model_store: require('./../../../civics-common/base/data_model_store.js'),
    generic_collection: require('./../../../civics-common/base/generic_collection.js'),
    generic_helper: require('./../../../civics-common/base/generic_helper.js'),
    generic_model: require('./../../../civics-common/base/generic_model.js'),
    handlebars_helpers: require('./../../../civics-common/base/handlebars_helpers.js'),
    handlebars_helpers_global: require('./../../../civics-common/base/handlebars_helpers_global.js'),
    ipsModel: require('./../../../civics-common/base/ipsModel.js'),
    ipsModelCollection: require('./../../../civics-common/base/ipsModelCollection.js'),
    modal: require('./../../../civics-common/base/modal.js'),
    'url-object': require('./../../../civics-common/base/url-object.js'),
    widget: require('./../../../civics-common/base/widget.js'),
  },
  collections: {
    additional_items_collection: require('./../../../civics-common/collections/additional_items_collection.js'),
    address_collection: require('./../../../civics-common/collections/address_collection.js'),
    agencymap_collection: require('./../../../civics-common/collections/agencymap_collection.js'),
    application_collection: require('./../../../civics-common/collections/application_collection.js'),
    application_status_checks: require('./../../../civics-common/collections/application_status_checks.js'),
    application_type_collection: require('./../../../civics-common/collections/application_type_collection.js'),
    applications_collection: require('./../../../civics-common/collections/applications_collection.js'),
    assignment_types_collection: require('./../../../civics-common/collections/assignment_types_collection.js'),
    assignmenttype_collection: require('./../../../civics-common/collections/assignmenttype_collection.js'),
    attachment_collection: require('./../../../civics-common/collections/attachment_collection.js'),
    attachment_constraints_collection: require('./../../../civics-common/collections/attachment_constraints_collection.js'),
    available_factors_collection: require('./../../../civics-common/collections/available_factors_collection.js'),
    cdr: {
      filter_code_collection: require('./../../../civics-common/collections/cdr/filter_code_collection.js'),
      project_children_collection: require('./../../../civics-common/collections/cdr/project_children_collection.js'),
    },
    code_definition_collection: require('./../../../civics-common/collections/code_definition_collection.js'),
    core: {
      autocomplete_collection: require('./../../../civics-common/collections/core/autocomplete_collection.js'),
      autocomplete_filtercode_collection: require('./../../../civics-common/collections/core/autocomplete_filtercode_collection.js'),
      autocomplete_md_collection: require('./../../../civics-common/collections/core/autocomplete_md_collection.js'),
    },
    crm: {
      service_request_types_collection: require('./../../../civics-common/collections/crm/service_request_types_collection.js'),
    },
    document_type_collection: require('./../../../civics-common/collections/document_type_collection.js'),
    fee_collection: require('./../../../civics-common/collections/fee_collection.js'),
    gis_key_collection: require('./../../../civics-common/collections/gis_key_collection.js'),
    hearing_logs_collection: require('./../../../civics-common/collections/hearing_logs_collection.js'),
    inspection_logs_collection: require('./../../../civics-common/collections/inspection_logs_collection.js'),
    inspection_result_code_collection: require('./../../../civics-common/collections/inspection_result_code_collection.js'),
    inspections_collection: require('./../../../civics-common/collections/inspections_collection.js'),
    instrument_collection: require('./../../../civics-common/collections/instrument_collection.js'),
    instrument_record_type_collection: require('./../../../civics-common/collections/instrument_record_type_collection.js'),
    instrument_type_collection: require('./../../../civics-common/collections/instrument_type_collection.js'),
    instrument_types_collection: require('./../../../civics-common/collections/instrument_types_collection.js'),
    internal_charge_collection: require('./../../../civics-common/collections/internal_charge_collection.js'),
    location: {
      location_autocomplete_collection: require('./../../../civics-common/collections/location/location_autocomplete_collection.js'),
      location_data_autocomplete_collection: require('./../../../civics-common/collections/location/location_data_autocomplete_collection.js'),
      nearest_address_collection: require('./../../../civics-common/collections/location/nearest_address_collection.js'),
      nearest_asset_collection: require('./../../../civics-common/collections/location/nearest_asset_collection.js'),
      nearest_collection_base: require('./../../../civics-common/collections/location/nearest_collection_base.js'),
      nearest_parcel_collection: require('./../../../civics-common/collections/location/nearest_parcel_collection.js'),
      nearest_site_collection: require('./../../../civics-common/collections/location/nearest_site_collection.js'),
    },
    milestone_collection: require('./../../../civics-common/collections/milestone_collection.js'),
    my_assignments_collection: require('./../../../civics-common/collections/my_assignments_collection.js'),
    my_projects_collection: require('./../../../civics-common/collections/my_projects_collection.js'),
    myassignmenttypes_collection: require('./../../../civics-common/collections/myassignmenttypes_collection.js'),
    payment_collection: require('./../../../civics-common/collections/payment_collection.js'),
    portal: {
      assignment_view_collection: require('./../../../civics-common/collections/portal/assignment_view_collection.js'),
      assignment_view_collection_card_view: require('./../../../civics-common/collections/portal/assignment_view_collection_card_view.js'),
      authorized_user_invitation_collection: require('./../../../civics-common/collections/portal/authorized_user_invitation_collection.js'),
      favorite_contact_collection: require('./../../../civics-common/collections/portal/favorite_contact_collection.js'),
      favorite_instrument_type_collection: require('./../../../civics-common/collections/portal/favorite_instrument_type_collection.js'),
      favorite_service_request_type_collection: require('./../../../civics-common/collections/portal/favorite_service_request_type_collection.js'),
      feature_collection: require('./../../../civics-common/collections/portal/feature_collection.js'),
      fee_collection: require('./../../../civics-common/collections/portal/fee_collection.js'),
      instrument_view_collection: require('./../../../civics-common/collections/portal/instrument_view_collection.js'),
      instrument_view_collection_plain: require('./../../../civics-common/collections/portal/instrument_view_collection_plain.js'),
      invitation_collection: require('./../../../civics-common/collections/portal/invitation_collection.js'),
      my_fees_collection: require('./../../../civics-common/collections/portal/my_fees_collection.js'),
      portal_fee_collection: require('./../../../civics-common/collections/portal/portal_fee_collection.js'),
      public_fee_collection: require('./../../../civics-common/collections/portal/public_fee_collection.js'),
      public_instruments_collection: require('./../../../civics-common/collections/portal/public_instruments_collection.js'),
      related_records_collection: require('./../../../civics-common/collections/portal/related_records_collection.js'),
      saved_searches_collection: require('./../../../civics-common/collections/portal/saved_searches_collection.js'),
      scenario_collection: require('./../../../civics-common/collections/portal/scenario_collection.js'),
      wizard_type_collection: require('./../../../civics-common/collections/portal/wizard_type_collection.js'),
    },
    problem_code_collection: require('./../../../civics-common/collections/problem_code_collection.js'),
    public_milestone_collection: require('./../../../civics-common/collections/public_milestone_collection.js'),
    related_application_collection: require('./../../../civics-common/collections/related_application_collection.js'),
    review_logs_collection: require('./../../../civics-common/collections/review_logs_collection.js'),
    review_result_code_collection: require('./../../../civics-common/collections/review_result_code_collection.js'),
    service_providers_collection: require('./../../../civics-common/collections/service_providers_collection.js'),
    simplified_notification_collection: require('./../../../civics-common/collections/simplified_notification_collection.js'),
    subtypes_collection: require('./../../../civics-common/collections/subtypes_collection.js'),
    tasks_type_collection: require('./../../../civics-common/collections/tasks_type_collection.js'),
    user_records_collection: require('./../../../civics-common/collections/user_records_collection.js'),
    violation_code_collection: require('./../../../civics-common/collections/violation_code_collection.js'),
  },
  models: {
    account_exist_model: require('./../../../civics-common/models/account_exist_model.js'),
    account_model: require('./../../../civics-common/models/account_model.js'),
    account_password_model: require('./../../../civics-common/models/account_password_model.js'),
    address_model: require('./../../../civics-common/models/address_model.js'),
    agencymap_model: require('./../../../civics-common/models/agencymap_model.js'),
    anonymous_login_model: require('./../../../civics-common/models/anonymous_login_model.js'),
    applicant_model: require('./../../../civics-common/models/applicant_model.js'),
    application_model: require('./../../../civics-common/models/application_model.js'),
    application_start_detail_model: require('./../../../civics-common/models/application_start_detail_model.js'),
    application_start_validation_model: require('./../../../civics-common/models/application_start_validation_model.js'),
    asset_model: require('./../../../civics-common/models/asset_model.js'),
    associated_property_model: require('./../../../civics-common/models/associated_property_model.js'),
    attachment_model: require('./../../../civics-common/models/attachment_model.js'),
    authenticate_token_model: require('./../../../civics-common/models/authenticate_token_model.js'),
    cashiering: {
      callback_model: require('./../../../civics-common/models/cashiering/callback_model.js'),
    },
    cashiering_payment_model: require('./../../../civics-common/models/cashiering_payment_model.js'),
    cdr_log_model: require('./../../../civics-common/models/cdr_log_model.js'),
    code_definition_model: require('./../../../civics-common/models/code_definition_model.js'),
    contact_model: require('./../../../civics-common/models/contact_model.js'),
    contact_type_code_model: require('./../../../civics-common/models/contact_type_code_model.js'),
    core: {
      activation_model: require('./../../../civics-common/models/core/activation_model.js'),
      autocomplete_filtercode_model: require('./../../../civics-common/models/core/autocomplete_filtercode_model.js'),
      detail_object_model: require('./../../../civics-common/models/core/detail_object_model.js'),
      detail_page_model: require('./../../../civics-common/models/core/detail_page_model.js'),
    },
    crm: {
      service_request_log_model: require('./../../../civics-common/models/crm/service_request_log_model.js'),
    },
    detail_generate_all_model: require('./../../../civics-common/models/detail_generate_all_model.js'),
    detail_generate_model: require('./../../../civics-common/models/detail_generate_model.js'),
    document_type_model: require('./../../../civics-common/models/document_type_model.js'),
    electronic_plan_review_model: require('./../../../civics-common/models/electronic_plan_review_model.js'),
    electronic_plans_submission_model: require('./../../../civics-common/models/electronic_plans_submission_model.js'),
    fee_model: require('./../../../civics-common/models/fee_model.js'),
    forgot_password_account_exist: require('./../../../civics-common/models/forgot_password_account_exist.js'),
    forgot_password_model: require('./../../../civics-common/models/forgot_password_model.js'),
    global_configuration_model: require('./../../../civics-common/models/global_configuration_model.js'),
    hearing_model: require('./../../../civics-common/models/hearing_model.js'),
    identity_model: require('./../../../civics-common/models/identity_model.js'),
    inspection_model: require('./../../../civics-common/models/inspection_model.js'),
    instrument_model: require('./../../../civics-common/models/instrument_model.js'),
    location: {
      map_extent_model: require('./../../../civics-common/models/location/map_extent_model.js'),
    },
    log_model: require('./../../../civics-common/models/log_model.js'),
    login_liferay_model: require('./../../../civics-common/models/login_liferay_model.js'),
    login_model: require('./../../../civics-common/models/login_model.js'),
    login_passwordReset_model: require('./../../../civics-common/models/login_passwordReset_model.js'),
    login_question_model: require('./../../../civics-common/models/login_question_model.js'),
    login_status_model: require('./../../../civics-common/models/login_status_model.js'),
    mfa_subscription_model: require('./../../../civics-common/models/mfa_subscription_model.js'),
    notification_method_code_model: require('./../../../civics-common/models/notification_method_code_model.js'),
    notification_model: require('./../../../civics-common/models/notification_model.js'),
    notification_type_code_model: require('./../../../civics-common/models/notification_type_code_model.js'),
    parcel_model: require('./../../../civics-common/models/parcel_model.js'),
    parent_child_relationship_model: require('./../../../civics-common/models/parent_child_relationship_model.js'),
    payment_model: require('./../../../civics-common/models/payment_model.js'),
    planning_condition_model: require('./../../../civics-common/models/planning_condition_model.js'),
    portal: {
      authentication: {
        profile_switch_model: require('./../../../civics-common/models/portal/authentication/profile_switch_model.js'),
      },
      authorized_user_accept_invitation_model: require('./../../../civics-common/models/portal/authorized_user_accept_invitation_model.js'),
      authorized_user_invitation_model: require('./../../../civics-common/models/portal/authorized_user_invitation_model.js'),
      authorized_user_invitation_token_model: require('./../../../civics-common/models/portal/authorized_user_invitation_token_model.js'),
      duplicate_applicants: require('./../../../civics-common/models/portal/duplicate_applicants.js'),
      favorite_contact_model: require('./../../../civics-common/models/portal/favorite_contact_model.js'),
      favorite_instrument_type_model: require('./../../../civics-common/models/portal/favorite_instrument_type_model.js'),
      favorite_service_request_type_model: require('./../../../civics-common/models/portal/favorite_service_request_type_model.js'),
      feature_activation_model: require('./../../../civics-common/models/portal/feature_activation_model.js'),
      feature_model: require('./../../../civics-common/models/portal/feature_model.js'),
      forgot_username_model: require('./../../../civics-common/models/portal/forgot_username_model.js'),
      instrument: require('./../../../civics-common/models/portal/instrument.js'),
      instrument_view_model: require('./../../../civics-common/models/portal/instrument_view_model.js'),
      invitation_model: require('./../../../civics-common/models/portal/invitation_model.js'),
      portal_defaults_model: require('./../../../civics-common/models/portal/portal_defaults_model.js'),
      portal_fee_model: require('./../../../civics-common/models/portal/portal_fee_model.js'),
      portal_total_fees: require('./../../../civics-common/models/portal/portal_total_fees.js'),
      portlet_configuration_model: require('./../../../civics-common/models/portal/portlet_configuration_model.js'),
      profile_default_model: require('./../../../civics-common/models/portal/profile_default_model.js'),
      reset_password_model: require('./../../../civics-common/models/portal/reset_password_model.js'),
      saved_searches: require('./../../../civics-common/models/portal/saved_searches.js'),
      scenario_model: require('./../../../civics-common/models/portal/scenario_model.js'),
      ui: {
        instrument_setup_model: require('./../../../civics-common/models/portal/ui/instrument_setup_model.js'),
      },
      wizard_model: require('./../../../civics-common/models/portal/wizard_model.js'),
      wizard_type_model: require('./../../../civics-common/models/portal/wizard_type_model.js'),
    },
    portal_instrument_model: require('./../../../civics-common/models/portal_instrument_model.js'),
    problem_code_model: require('./../../../civics-common/models/problem_code_model.js'),
    property_model: require('./../../../civics-common/models/property_model.js'),
    public_payment_confirmation_model: require('./../../../civics-common/models/public_payment_confirmation_model.js'),
    register_account_model: require('./../../../civics-common/models/register_account_model.js'),
    register_organization_model: require('./../../../civics-common/models/register_organization_model.js'),
    related_records_model: require('./../../../civics-common/models/related_records_model.js'),
    report_properties_model: require('./../../../civics-common/models/report_properties_model.js'),
    request_inspection_model: require('./../../../civics-common/models/request_inspection_model.js'),
    review_model: require('./../../../civics-common/models/review_model.js'),
    security_question_model: require('./../../../civics-common/models/security_question_model.js'),
    send_email_model: require('./../../../civics-common/models/send_email_model.js'),
    service_request_model: require('./../../../civics-common/models/service_request_model.js'),
    social_identity_model: require('./../../../civics-common/models/social_identity_model.js'),
    sr_start_validation_model: require('./../../../civics-common/models/sr_start_validation_model.js'),
    'styleguide_ui-component_model': require('./../../../civics-common/models/styleguide_ui-component_model.js'),
    sync_model: require('./../../../civics-common/models/sync_model.js'),
    transaction_model: require('./../../../civics-common/models/transaction_model.js'),
    validate_password_model: require('./../../../civics-common/models/validate_password_model.js'),
    violation_code_model: require('./../../../civics-common/models/violation_code_model.js'),
  },
  utilities: {
    JSV: require('./../../../civics-common/utilities/JSV.js'),
    UrlParameters: require('./../../../civics-common/utilities/UrlParameters.js'),
    activation_utility: require('./../../../civics-common/utilities/activation_utility.js'),
    application: {
      logger: require('./../../../civics-common/utilities/application/logger.js'),
    },
    attachment_converter: require('./../../../civics-common/utilities/attachment_converter.js'),
    attachment_utility: require('./../../../civics-common/utilities/attachment_utility.js'),
    authorized_user_utils: require('./../../../civics-common/utilities/authorized_user_utils.js'),
    autocomplete: require('./../../../civics-common/utilities/autocomplete.js'),
    available_features: require('./../../../civics-common/utilities/available_features.js'),
    'backbone-nestedvalidation': require('./../../../civics-common/utilities/backbone-nestedvalidation.js'),
    buildUrlParameters: require('./../../../civics-common/utilities/buildUrlParameters.js'),
    cache_utility: require('./../../../civics-common/utilities/cache_utility.js'),
    canvas: require('./../../../civics-common/utilities/canvas.js'),
    civicsDroppy: require('./../../../civics-common/utilities/civicsDroppy.js'),
    collection_manager: require('./../../../civics-common/utilities/collection_manager.js'),
    constants: require('./../../../civics-common/utilities/constants.js'),
    constraint_parser: require('./../../../civics-common/utilities/constraint_parser.js'),
    date_utilities: require('./../../../civics-common/utilities/date_utilities.js'),
    detail_utilities: require('./../../../civics-common/utilities/detail_utilities.js'),
    electronicplan_utilities: require('./../../../civics-common/utilities/electronicplan_utilities.js'),
    extended_filter_utility: require('./../../../civics-common/utilities/extended_filter_utility.js'),
    featureToggleConstants: require('./../../../civics-common/utilities/featureToggleConstants.js'),
    featureToggleUtility: require('./../../../civics-common/utilities/featureToggleUtility.js'),
    field_change_utility: require('./../../../civics-common/utilities/field_change_utility.js'),
    general_utilities: require('./../../../civics-common/utilities/general_utilities.js'),
    generic_filter_codes: require('./../../../civics-common/utilities/generic_filter_codes.js'),
    gis_sync_utilities: require('./../../../civics-common/utilities/gis_sync_utilities.js'),
    i18n_prefix_override: require('./../../../civics-common/utilities/i18n_prefix_override.js'),
    inspection_review_button_functions: require('./../../../civics-common/utilities/inspection_review_button_functions.js'),
    instrument_utilities: require('./../../../civics-common/utilities/instrument_utilities.js'),
    internet_explorer_find_patch: require('./../../../civics-common/utilities/internet_explorer_find_patch.js'),
    invitation_utilities: require('./../../../civics-common/utilities/invitation_utilities.js'),
    libraries: {
      big: require('./../../../civics-common/utilities/libraries/big.js'),
    },
    live_region_utility: require('./../../../civics-common/utilities/live_region_utility.js'),
    loading_manager: require('./../../../civics-common/utilities/loading_manager.js'),
    login_error_utility: require('./../../../civics-common/utilities/login_error_utility.js'),
    map_utilities: require('./../../../civics-common/utilities/map_utilities.js'),
    mimetype_utilities: require('./../../../civics-common/utilities/mimetype_utilities.js'),
    mobile_utility: require('./../../../civics-common/utilities/mobile_utility.js'),
    modal_region: require('./../../../civics-common/utilities/modal_region.js'),
    oauth_helper: require('./../../../civics-common/utilities/oauth_helper.js'),
    password_validator: require('./../../../civics-common/utilities/password_validator.js'),
    portlet_configuration_utilities: require('./../../../civics-common/utilities/portlet_configuration_utilities.js'),
    portlet_control_change_manager: require('./../../../civics-common/utilities/portlet_control_change_manager.js'),
    process_manager: {
      process_constants: require('./../../../civics-common/utilities/process_manager/process_constants.js'),
      process_manager: require('./../../../civics-common/utilities/process_manager/process_manager.js'),
      session_utilities: require('./../../../civics-common/utilities/process_manager/session_utilities.js'),
    },
    share_filter_persistence: require('./../../../civics-common/utilities/share_filter_persistence.js'),
    site_builder: require('./../../../civics-common/utilities/site_builder.js'),
    sso: {
      sso_util: require('./../../../civics-common/utilities/sso/sso_util.js'),
    },
    type_utilities: require('./../../../civics-common/utilities/type_utilities.js'),
    user_data_utils: require('./../../../civics-common/utilities/user_data_utils.js'),
    user_utils: require('./../../../civics-common/utilities/user_utils.js'),
    version_manager: require('./../../../civics-common/utilities/version_manager.js'),
    view_binding_manager: require('./../../../civics-common/utilities/view_binding_manager.js'),
    view_builder: {
      detail_utilities: require('./../../../civics-common/utilities/view_builder/detail_utilities.js'),
      elements: {
        checkBox: require('./../../../civics-common/utilities/view_builder/elements/checkBox.js'),
        dateTime: require('./../../../civics-common/utilities/view_builder/elements/dateTime.js'),
        dropdown: require('./../../../civics-common/utilities/view_builder/elements/dropdown.js'),
        label: require('./../../../civics-common/utilities/view_builder/elements/label.js'),
        map: require('./../../../civics-common/utilities/view_builder/elements/map.js'),
        radioButton: require('./../../../civics-common/utilities/view_builder/elements/radioButton.js'),
        table: require('./../../../civics-common/utilities/view_builder/elements/table.js'),
        tabs: require('./../../../civics-common/utilities/view_builder/elements/tabs.js'),
        textBox: require('./../../../civics-common/utilities/view_builder/elements/textBox.js'),
      },
      table_functions: require('./../../../civics-common/utilities/view_builder/table_functions.js'),
      template_generator: require('./../../../civics-common/utilities/view_builder/template_generator.js'),
      view_builder: require('./../../../civics-common/utilities/view_builder/view_builder.js'),
    },
    view_manager: require('./../../../civics-common/utilities/view_manager.js'),
    wizard_utility: require('./../../../civics-common/utilities/wizard_utility.js'),
  },
  views: {
    AddApplicant: {
      v_lov_add_applicant: require('./../../../civics-common/views/AddApplicant/v_lov_add_applicant.js'),
    },
    EditSites: {
      v_cpv_results_list_view: require('./../../../civics-common/views/EditSites/v_cpv_results_list_view.js'),
      v_itv_edit_sites_search_results: require('./../../../civics-common/views/EditSites/v_itv_edit_sites_search_results.js'),
      v_lov_edit_sites: require('./../../../civics-common/views/EditSites/v_lov_edit_sites.js'),
      v_lov_map_view: require('./../../../civics-common/views/EditSites/v_lov_map_view.js'),
      v_lov_results_view: require('./../../../civics-common/views/EditSites/v_lov_results_view.js'),
      v_lov_site_map: require('./../../../civics-common/views/EditSites/v_lov_site_map.js'),
    },
    InviteApplicant: {
      v_cpv_invite_applicant: require('./../../../civics-common/views/InviteApplicant/v_cpv_invite_applicant.js'),
      v_itv_invite_applicant: require('./../../../civics-common/views/InviteApplicant/v_itv_invite_applicant.js'),
      v_itv_invite_notifications: require('./../../../civics-common/views/InviteApplicant/v_itv_invite_notifications.js'),
      v_lov_invite_applicant: require('./../../../civics-common/views/InviteApplicant/v_lov_invite_applicant.js'),
    },
    InviteAuthorizedUsers: {
      v_cpv_invite_authorized_users: require('./../../../civics-common/views/InviteAuthorizedUsers/v_cpv_invite_authorized_users.js'),
      v_itv_invite_authorized_users: require('./../../../civics-common/views/InviteAuthorizedUsers/v_itv_invite_authorized_users.js'),
      v_itv_invite_notifications: require('./../../../civics-common/views/InviteAuthorizedUsers/v_itv_invite_notifications.js'),
    },
    advanced_location_selection_view: {
      CDR: {
        '2204_location_selection_logic': require('./../../../civics-common/views/advanced_location_selection_view/CDR/2204_location_selection_logic.js'),
        '2207_location_selection_logic': require('./../../../civics-common/views/advanced_location_selection_view/CDR/2207_location_selection_logic.js'),
        v_lov_location_selection: require('./../../../civics-common/views/advanced_location_selection_view/CDR/v_lov_location_selection.js'),
        v_lov_map_toggle: require('./../../../civics-common/views/advanced_location_selection_view/CDR/v_lov_map_toggle.js'),
      },
      CRM: {
        location_selection_logic: require('./../../../civics-common/views/advanced_location_selection_view/CRM/location_selection_logic.js'),
        v_lov_location_selection: require('./../../../civics-common/views/advanced_location_selection_view/CRM/v_lov_location_selection.js'),
        v_lov_map_toggle: require('./../../../civics-common/views/advanced_location_selection_view/CRM/v_lov_map_toggle.js'),
      },
      combined: {
        location_picker: {
          v_cpv_lp_list: require('./../../../civics-common/views/advanced_location_selection_view/combined/location_picker/v_cpv_lp_list.js'),
          v_itv_lp_item: require('./../../../civics-common/views/advanced_location_selection_view/combined/location_picker/v_itv_lp_item.js'),
          v_lov_location_picker: require('./../../../civics-common/views/advanced_location_selection_view/combined/location_picker/v_lov_location_picker.js'),
        },
        logic: {
          autocomplete_logic: require('./../../../civics-common/views/advanced_location_selection_view/combined/logic/autocomplete_logic.js'),
          data_handling_logic: require('./../../../civics-common/views/advanced_location_selection_view/combined/logic/data_handling_logic.js'),
          geolocation_logic: require('./../../../civics-common/views/advanced_location_selection_view/combined/logic/geolocation_logic.js'),
          main_logic: require('./../../../civics-common/views/advanced_location_selection_view/combined/logic/main_logic.js'),
          map_logic: require('./../../../civics-common/views/advanced_location_selection_view/combined/logic/map_logic.js'),
          site_selection_logic: require('./../../../civics-common/views/advanced_location_selection_view/combined/logic/site_selection_logic.js'),
        },
        selected_sites: {
          v_cpv_ss_list: require('./../../../civics-common/views/advanced_location_selection_view/combined/selected_sites/v_cpv_ss_list.js'),
          v_itv_ss_item: require('./../../../civics-common/views/advanced_location_selection_view/combined/selected_sites/v_itv_ss_item.js'),
          v_lov_selected_sites: require('./../../../civics-common/views/advanced_location_selection_view/combined/selected_sites/v_lov_selected_sites.js'),
        },
        v_lov_location_selection: require('./../../../civics-common/views/advanced_location_selection_view/combined/v_lov_location_selection.js'),
        v_lov_map_toggle: require('./../../../civics-common/views/advanced_location_selection_view/combined/v_lov_map_toggle.js'),
      },
      utilities: {
        big: require('./../../../civics-common/views/advanced_location_selection_view/utilities/big.js'),
      },
    },
    agencymap_view: {
      v_agencymap: require('./../../../civics-common/views/agencymap_view/v_agencymap.js'),
    },
    assign_review: {
      common: {
        common: require('./../../../civics-common/views/assign_review/common/common.js'),
      },
      v_itv_assign_review: require('./../../../civics-common/views/assign_review/v_itv_assign_review.js'),
      v_itv_review_cancel_assignment: require('./../../../civics-common/views/assign_review/v_itv_review_cancel_assignment.js'),
      v_itv_review_cancel_request: require('./../../../civics-common/views/assign_review/v_itv_review_cancel_request.js'),
    },
    attachments: {
      v_cpv_add_attachments: require('./../../../civics-common/views/attachments/v_cpv_add_attachments.js'),
      v_cpv_attachments_list: require('./../../../civics-common/views/attachments/v_cpv_attachments_list.js'),
      v_cpv_attributes: require('./../../../civics-common/views/attachments/v_cpv_attributes.js'),
      v_itv_add_attachment: require('./../../../civics-common/views/attachments/v_itv_add_attachment.js'),
      v_itv_attachment_viewer: require('./../../../civics-common/views/attachments/v_itv_attachment_viewer.js'),
      v_itv_attachments_list: require('./../../../civics-common/views/attachments/v_itv_attachments_list.js'),
      v_itv_attribute_item: require('./../../../civics-common/views/attachments/v_itv_attribute_item.js'),
      v_lov_attachments_list: require('./../../../civics-common/views/attachments/v_lov_attachments_list.js'),
    },
    card_view_list: {
      instrumentMappings: require('./../../../civics-common/views/card_view_list/instrumentMappings.js'),
      utilities: {
        card_view_utilities: require('./../../../civics-common/views/card_view_list/utilities/card_view_utilities.js'),
      },
      views: {
        v_lov_card_view_list: require('./../../../civics-common/views/card_view_list/views/v_lov_card_view_list.js'),
        v_lov_row_view: require('./../../../civics-common/views/card_view_list/views/v_lov_row_view.js'),
      },
    },
    card_views: {
      action: {
        views: {
          v_cpv_action_card: require('./../../../civics-common/views/card_views/action/views/v_cpv_action_card.js'),
          v_itv_action_data_item: require('./../../../civics-common/views/card_views/action/views/v_itv_action_data_item.js'),
        },
      },
      description: {
        defaults: require('./../../../civics-common/views/card_views/description/defaults.js'),
        views: {
          v_cpv_card_menu: require('./../../../civics-common/views/card_views/description/views/v_cpv_card_menu.js'),
          v_itv_menu_item: require('./../../../civics-common/views/card_views/description/views/v_itv_menu_item.js'),
          v_lov_description_card: require('./../../../civics-common/views/card_views/description/views/v_lov_description_card.js'),
        },
      },
      standard: {
        defaults: require('./../../../civics-common/views/card_views/standard/defaults.js'),
        views: {
          v_cpv_card_view: require('./../../../civics-common/views/card_views/standard/views/v_cpv_card_view.js'),
          v_itv_data_item: require('./../../../civics-common/views/card_views/standard/views/v_itv_data_item.js'),
        },
      },
    },
    code_violations: {
      v_cpv_violations: require('./../../../civics-common/views/code_violations/v_cpv_violations.js'),
      v_itv_violation_item: require('./../../../civics-common/views/code_violations/v_itv_violation_item.js'),
      v_lov_violations: require('./../../../civics-common/views/code_violations/v_lov_violations.js'),
    },
    confirmation_modal: {
      v_lov_confirmation_modal: require('./../../../civics-common/views/confirmation_modal/v_lov_confirmation_modal.js'),
    },
    core: {
      confirmation: {
        v_itv_confirmation: require('./../../../civics-common/views/core/confirmation/v_itv_confirmation.js'),
        v_mv_confirmation: require('./../../../civics-common/views/core/confirmation/v_mv_confirmation.js'),
      },
      core_constants: require('./../../../civics-common/views/core/core_constants.js'),
      login: {
        logged_in_user: {
          v_lov_logged_in_user: require('./../../../civics-common/views/core/login/logged_in_user/v_lov_logged_in_user.js'),
        },
        login_customsso: {
          v_itv_login_signin: require('./../../../civics-common/views/core/login/login_customsso/v_itv_login_signin.js'),
          v_lov_login: require('./../../../civics-common/views/core/login/login_customsso/v_lov_login.js'),
          v_lov_login_signin: require('./../../../civics-common/views/core/login/login_customsso/v_lov_login_signin.js'),
        },
        login_standard: {
          v_itv_activation_failed: require('./../../../civics-common/views/core/login/login_standard/v_itv_activation_failed.js'),
          v_itv_login_guest: require('./../../../civics-common/views/core/login/login_standard/v_itv_login_guest.js'),
          v_itv_login_passwordReset: require('./../../../civics-common/views/core/login/login_standard/v_itv_login_passwordReset.js'),
          v_itv_login_question: require('./../../../civics-common/views/core/login/login_standard/v_itv_login_question.js'),
          v_itv_login_signin: require('./../../../civics-common/views/core/login/login_standard/v_itv_login_signin.js'),
          v_lov_login: require('./../../../civics-common/views/core/login/login_standard/v_lov_login.js'),
          v_lov_login_guest: require('./../../../civics-common/views/core/login/login_standard/v_lov_login_guest.js'),
          v_lov_login_passwordReset: require('./../../../civics-common/views/core/login/login_standard/v_lov_login_passwordReset.js'),
          v_lov_login_question: require('./../../../civics-common/views/core/login/login_standard/v_lov_login_question.js'),
          v_lov_login_signin: require('./../../../civics-common/views/core/login/login_standard/v_lov_login_signin.js'),
        },
        social: {
          v_itv_warn_existing_account: require('./../../../civics-common/views/core/login/social/v_itv_warn_existing_account.js'),
        },
        v_lov_login: require('./../../../civics-common/views/core/login/v_lov_login.js'),
      },
      two_factor_authentication: {
        '2fa_response_utils': require('./../../../civics-common/views/core/two_factor_authentication/2fa_response_utils.js'),
        '2fa_utility': require('./../../../civics-common/views/core/two_factor_authentication/2fa_utility.js'),
        authentication_view: {
          v_lov_authentication: require('./../../../civics-common/views/core/two_factor_authentication/authentication_view/v_lov_authentication.js'),
        },
        enforced_setup: {
          utils: {
            step_animation_utils: require('./../../../civics-common/views/core/two_factor_authentication/enforced_setup/utils/step_animation_utils.js'),
          },
          views: {
            v_lov_enforced_setup: require('./../../../civics-common/views/core/two_factor_authentication/enforced_setup/views/v_lov_enforced_setup.js'),
            v_lov_mfa_success: require('./../../../civics-common/views/core/two_factor_authentication/enforced_setup/views/v_lov_mfa_success.js'),
            v_lov_unified_mfa_setup: require('./../../../civics-common/views/core/two_factor_authentication/enforced_setup/views/v_lov_unified_mfa_setup.js'),
          },
        },
        setup_view: {
          v_lov_setup: require('./../../../civics-common/views/core/two_factor_authentication/setup_view/v_lov_setup.js'),
        },
      },
    },
    create_log: {
      v_lov_create_log: require('./../../../civics-common/views/create_log/v_lov_create_log.js'),
    },
    detail_view: {
      modal_view: {
        detail_utilities: require('./../../../civics-common/views/detail_view/modal_view/detail_utilities.js'),
        elements: {
          v_itv_base_element: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_base_element.js'),
          v_itv_checkbox_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_checkbox_field.js'),
          v_itv_currency_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_currency_field.js'),
          v_itv_date_time_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_date_time_field.js'),
          v_itv_decimal_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_decimal_field.js'),
          v_itv_dropdown_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_dropdown_field.js'),
          v_itv_edit_delete_icon: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_edit_delete_icon.js'),
          v_itv_label: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_label.js'),
          v_itv_map_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_map_field.js'),
          v_itv_number_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_number_field.js'),
          v_itv_radio_button_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_radio_button_field.js'),
          v_itv_text_field: require('./../../../civics-common/views/detail_view/modal_view/elements/v_itv_text_field.js'),
        },
        grid: {
          v_cpv_grid_row: require('./../../../civics-common/views/detail_view/modal_view/grid/v_cpv_grid_row.js'),
          v_cpv_grid_table: require('./../../../civics-common/views/detail_view/modal_view/grid/v_cpv_grid_table.js'),
          v_lov_detail_grid: require('./../../../civics-common/views/detail_view/modal_view/grid/v_lov_detail_grid.js'),
        },
        v_cpv_elements_list: require('./../../../civics-common/views/detail_view/modal_view/v_cpv_elements_list.js'),
        v_lov_modal_detail: require('./../../../civics-common/views/detail_view/modal_view/v_lov_modal_detail.js'),
      },
      v_cpv_add_details: require('./../../../civics-common/views/detail_view/v_cpv_add_details.js'),
      v_cpv_details: require('./../../../civics-common/views/detail_view/v_cpv_details.js'),
      v_itv_add_detail: require('./../../../civics-common/views/detail_view/v_itv_add_detail.js'),
      v_itv_detail: require('./../../../civics-common/views/detail_view/v_itv_detail.js'),
      v_itv_detail_base: require('./../../../civics-common/views/detail_view/v_itv_detail_base.js'),
      v_lov_details: require('./../../../civics-common/views/detail_view/v_lov_details.js'),
    },
    dynamic_form: {
      v_lov_dynamic_form: require('./../../../civics-common/views/dynamic_form/v_lov_dynamic_form.js'),
    },
    electronic_plans: {
      v_itv_electronic_plans: require('./../../../civics-common/views/electronic_plans/v_itv_electronic_plans.js'),
    },
    favoriteContacts: {
      add_favorite_modal: {
        v_cpv_add_favorites_modal: require('./../../../civics-common/views/favoriteContacts/add_favorite_modal/v_cpv_add_favorites_modal.js'),
        v_itv_add_favorites_modal: require('./../../../civics-common/views/favoriteContacts/add_favorite_modal/v_itv_add_favorites_modal.js'),
      },
      controllers: {
        data_controller: require('./../../../civics-common/views/favoriteContacts/controllers/data_controller.js'),
        main_controller: require('./../../../civics-common/views/favoriteContacts/controllers/main_controller.js'),
      },
      v_clv_favorites: require('./../../../civics-common/views/favoriteContacts/v_clv_favorites.js'),
      v_itv_select_favorite: require('./../../../civics-common/views/favoriteContacts/v_itv_select_favorite.js'),
      v_lov_empty_view: require('./../../../civics-common/views/favoriteContacts/v_lov_empty_view.js'),
      v_lov_favorite: require('./../../../civics-common/views/favoriteContacts/v_lov_favorite.js'),
      v_lov_select_favorite: require('./../../../civics-common/views/favoriteContacts/v_lov_select_favorite.js'),
    },
    filter_view: {
      address_filter: require('./../../../civics-common/views/filter_view/address_filter.js'),
      manage_saved_searches_modal: {
        v_cpv_manage_saved_searches_modal: require('./../../../civics-common/views/filter_view/manage_saved_searches_modal/v_cpv_manage_saved_searches_modal.js'),
        v_itv_manage_saved_searches: require('./../../../civics-common/views/filter_view/manage_saved_searches_modal/v_itv_manage_saved_searches.js'),
      },
      save_search_modal: {
        v_cpv_save_search_modal: require('./../../../civics-common/views/filter_view/save_search_modal/v_cpv_save_search_modal.js'),
      },
      saved_searches_view: {
        v_cpv_saved_searches: require('./../../../civics-common/views/filter_view/saved_searches_view/v_cpv_saved_searches.js'),
        v_itv_saved_searches: require('./../../../civics-common/views/filter_view/saved_searches_view/v_itv_saved_searches.js'),
        v_lov_saved_searches: require('./../../../civics-common/views/filter_view/saved_searches_view/v_lov_saved_searches.js'),
      },
      v_itv_filter: require('./../../../civics-common/views/filter_view/v_itv_filter.js'),
    },
    inspection_request: {
      common: {
        common: require('./../../../civics-common/views/inspection_request/common/common.js'),
      },
      v_itv_inspection_cancel_assignment: require('./../../../civics-common/views/inspection_request/v_itv_inspection_cancel_assignment.js'),
      v_itv_inspection_cancel_request: require('./../../../civics-common/views/inspection_request/v_itv_inspection_cancel_request.js'),
      v_itv_inspection_request: require('./../../../civics-common/views/inspection_request/v_itv_inspection_request.js'),
    },
    inspection_results: {
      action: {
        v_cpv_inspection_actions: require('./../../../civics-common/views/inspection_results/action/v_cpv_inspection_actions.js'),
        v_itv_action_data_item: require('./../../../civics-common/views/inspection_results/action/v_itv_action_data_item.js'),
      },
      v_cpv_inspection_results: require('./../../../civics-common/views/inspection_results/v_cpv_inspection_results.js'),
      v_itv_inspection_result_item: require('./../../../civics-common/views/inspection_results/v_itv_inspection_result_item.js'),
      v_lov_inspection_results: require('./../../../civics-common/views/inspection_results/v_lov_inspection_results.js'),
    },
    log_links: {
      v_cpv_log_links: require('./../../../civics-common/views/log_links/v_cpv_log_links.js'),
      v_itv_log_link: require('./../../../civics-common/views/log_links/v_itv_log_link.js'),
    },
    logs_view: {
      v_cpv_logs: require('./../../../civics-common/views/logs_view/v_cpv_logs.js'),
      v_itv_log_item: require('./../../../civics-common/views/logs_view/v_itv_log_item.js'),
      v_lov_logs: require('./../../../civics-common/views/logs_view/v_lov_logs.js'),
    },
    long_message_modal: {
      v_lov_long_message_modal: require('./../../../civics-common/views/long_message_modal/v_lov_long_message_modal.js'),
    },
    map_view: {
      v_cpqmap: require('./../../../civics-common/views/map_view/v_cpqmap.js'),
      v_cpv_results_list_view: require('./../../../civics-common/views/map_view/v_cpv_results_list_view.js'),
      v_itv_edit_sites_search_results: require('./../../../civics-common/views/map_view/v_itv_edit_sites_search_results.js'),
      v_lov_results_view: require('./../../../civics-common/views/map_view/v_lov_results_view.js'),
    },
    new_attachments: {
      info_modal: {
        v_itv_attachment_viewer: require('./../../../civics-common/views/new_attachments/info_modal/v_itv_attachment_viewer.js'),
      },
      upload_modal: {
        v_cpv_add_attachments: require('./../../../civics-common/views/new_attachments/upload_modal/v_cpv_add_attachments.js'),
        v_itv_add_attachment: require('./../../../civics-common/views/new_attachments/upload_modal/v_itv_add_attachment.js'),
      },
      v_cpv_attachment_group_list: require('./../../../civics-common/views/new_attachments/v_cpv_attachment_group_list.js'),
      v_itv_attachment: require('./../../../civics-common/views/new_attachments/v_itv_attachment.js'),
      v_lov_attachment_group_row: require('./../../../civics-common/views/new_attachments/v_lov_attachment_group_row.js'),
      v_lov_attachments_box: require('./../../../civics-common/views/new_attachments/v_lov_attachments_box.js'),
    },
    page_view: {
      v_itv_page: require('./../../../civics-common/views/page_view/v_itv_page.js'),
    },
    paging_view: {
      v_cpv_paging_view: require('./../../../civics-common/views/paging_view/v_cpv_paging_view.js'),
      v_lov_paging_view: require('./../../../civics-common/views/paging_view/v_lov_paging_view.js'),
    },
    parent_instrument_summary: {
      v_itv_parent_instrument_summary: require('./../../../civics-common/views/parent_instrument_summary/v_itv_parent_instrument_summary.js'),
    },
    payment_summary: {
      v_cpv_payment_summary: require('./../../../civics-common/views/payment_summary/v_cpv_payment_summary.js'),
      v_itv_payment_summary: require('./../../../civics-common/views/payment_summary/v_itv_payment_summary.js'),
      v_lov_payment_summary: require('./../../../civics-common/views/payment_summary/v_lov_payment_summary.js'),
    },
    problems: {
      v_cpv_problems: require('./../../../civics-common/views/problems/v_cpv_problems.js'),
      v_itv_problem_empty: require('./../../../civics-common/views/problems/v_itv_problem_empty.js'),
      v_itv_problem_item: require('./../../../civics-common/views/problems/v_itv_problem_item.js'),
      v_lov_problems: require('./../../../civics-common/views/problems/v_lov_problems.js'),
    },
    search_view: {
      v_cpv_records_list: require('./../../../civics-common/views/search_view/v_cpv_records_list.js'),
      v_itv_empty_record_list: require('./../../../civics-common/views/search_view/v_itv_empty_record_list.js'),
      v_lov_search_view: require('./../../../civics-common/views/search_view/v_lov_search_view.js'),
    },
    send_email: {
      v_cpv_email: require('./../../../civics-common/views/send_email/v_cpv_email.js'),
      v_cpv_send_email: require('./../../../civics-common/views/send_email/v_cpv_send_email.js'),
      v_itv_email: require('./../../../civics-common/views/send_email/v_itv_email.js'),
    },
    share_email_view: {
      v_itv_url: require('./../../../civics-common/views/share_email_view/v_itv_url.js'),
      v_lov_share_url_modal: require('./../../../civics-common/views/share_email_view/v_lov_share_url_modal.js'),
    },
    share_url: {
      v_itv_url: require('./../../../civics-common/views/share_url/v_itv_url.js'),
      v_lov_share_url_modal: require('./../../../civics-common/views/share_url/v_lov_share_url_modal.js'),
    },
    view_documents: {
      report_view_utilities: require('./../../../civics-common/views/view_documents/report_view_utilities.js'),
      v_cpv_document_box: require('./../../../civics-common/views/view_documents/v_cpv_document_box.js'),
      v_itv_view_document: require('./../../../civics-common/views/view_documents/v_itv_view_document.js'),
      v_lov_view_documents: require('./../../../civics-common/views/view_documents/v_lov_view_documents.js'),
      v_mv_view_documents: require('./../../../civics-common/views/view_documents/v_mv_view_documents.js'),
    },
  },
};
